import React, {Component} from 'react';
import {Route, withRouter} from 'react-router-dom';
import App from "./App";
import Login from "./Screens/Login";
import Error from "./Screens/Error";
import NotFound from "./Screens/NotFound";
import Access from "./Screens/Access";


const $ = window.$;

class AppWrapper extends Component {
	componentDidUpdate(prevProps) {
		if (this.props.location !== prevProps.location) {
			window.scrollTo(0, 0)
		}
	}

	render() {		
		switch(this.props.location.pathname) {
			case "/login":
				return <Route path="/login" component={Login}/>
			case "/error":
				return <Route path="/error" component={Error}/>
			case "/404":
				return <Route path="/404" component={NotFound}/>
			case "/accessdenied":
				return <Route path="/accessdenied" component={Access}/>
			default:
				return <App/>;
		}
	}
}

export default withRouter(AppWrapper);